module.exports = __webpack_public_path__ + "static/bars3-61f53e457671852fea07bfe3df2d57a7.png";